import { colors } from "@/theme/colors";
import { IllustrationSvg } from "./IllustrationSvg";
import { Backdrop } from "./shapes";

/** Decorative launch sparks: [cx, cy, r, color, opacity]. */
const SPARKS: ReadonlyArray<[number, number, number, string, number]> = [
  [64, 44, 3, colors.primary, 0.4],
  [156, 58, 3, colors.primary, 0.4],
  [150, 32, 2.5, colors.secondary, 0.5],
];

/**
 * Flat illustration for the Ship step: a rocket lifting off with a "live"
 * badge — deployed to your infrastructure and launched.
 */
export function ShipIllustration() {
  return (
    <IllustrationSvg>
      {/* Soft backdrop */}
      <Backdrop x={44} y={20} width={132} height={98} fill={colors.paper} />
      {/* Exhaust flames */}
      <path d="M103 80h14l-7 26z" fill={colors.warning} />
      <path d="M106 80h8l-4 16z" fill={colors.secondary} opacity="0.7" />
      {/* Fins */}
      <path d="M97 70l-13 18 13-4z" fill={colors.secondary} />
      <path d="M123 70l13 18-13-4z" fill={colors.secondary} />
      {/* Rocket body */}
      <path
        d="M110 16c-9 6-13 20-13 34v30h26V50c0-14-4-28-13-34z"
        fill={colors.primary}
      />
      {/* Porthole */}
      <circle
        cx="110"
        cy="46"
        r="8"
        fill={colors.paper}
        stroke={colors.secondary}
        strokeWidth="2.5"
      />
      {/* Launch sparks */}
      {SPARKS.map(([cx, cy, r, fill, opacity]) => (
        <circle
          key={`${cx}-${cy}`}
          cx={cx}
          cy={cy}
          r={r}
          fill={fill}
          opacity={opacity}
        />
      ))}
      {/* Live badge */}
      <rect
        x="136"
        y="92"
        width="40"
        height="16"
        rx="8"
        fill={colors.paper}
        stroke={colors.divider}
        strokeWidth="1.5"
      />
      <circle cx="146" cy="100" r="3" fill={colors.success} />
      <rect
        x="153"
        y="97.5"
        width="15"
        height="5"
        rx="2.5"
        fill={colors.success}
        opacity="0.55"
      />
    </IllustrationSvg>
  );
}
